import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EImageUsage } from '../../enums/image-usage.enums';

@Component({
  selector: 'stxt-skeleton-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skeleton-loader.component.html',
  styleUrl: './skeleton-loader.component.scss'
})
export class SkeletonLoaderComponent {
  @Input() usage: EImageUsage = EImageUsage.PaymentForm;
  @Input() customClass: string = '';

  protected readonly EImageUsage = EImageUsage;
}
